import map from 'lodash/map';

import { FlexBoxRow } from '@r1-frontend/ui-react/components/layouts/flexBoxGrid';
import WideContainer from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { H2 } from '@r1-frontend/ui-react/components/typography/heading';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';

import { useValueByBreakpoint } from '~/src/helpers/hooks/useValueByBreakpoint';

import Apps from '../Apps';
import ContentBlock from '../ContentBlock';
import Disclaimer from '../Disclaimer';
import Join from '../Join';

import { productsData } from './data';

import * as ST from './styled';

interface IProps {
    hasNegativeMarginTop: boolean,
}

const Products = ({ hasNegativeMarginTop }: IProps) => {
    const currentWidth = useValueByBreakpoint({
        desktop: 'desktop',
        laptop: 'laptop',
        mobile: 'mobile',
    });

    return (
        <ST.SBlockContainer indent={{ $desktop: [80, 0], $mobile: [32, 0, 64] }} rounder={{ $radius: 32 }} hasNegativeMarginTop={hasNegativeMarginTop}>
            <WideContainer>
                <IndentContainer as='section' $desktop={[16, 0, 64]} $mobile={[0, 0, 32]}>
                    <H2>Наши продукты меняют жизнь к&nbsp;лучшему</H2>
                    {currentWidth === 'desktop' && (
                        <>
                            <FlexBoxRow data-test='desktop-row'>
                                <ST.Col md={6} lg={4}>
                                    <ContentBlock  {...productsData.internet} />
                                    <ContentBlock  {...productsData.videocontrol} />
                                </ST.Col>
                                <ST.Col md={6} lg={4}>
                                    <ContentBlock  {...productsData.tv} contentReverse />
                                    <ContentBlock  {...productsData.domofon} contentReverse />
                                </ST.Col>
                                <ST.Col md={6} lg={4}>
                                    <ContentBlock  {...productsData.movix} />
                                    <Apps />
                                </ST.Col>
                            </FlexBoxRow>
                            <Join />
                        </>
                    )}
                    {currentWidth === 'laptop' && (
                        <FlexBoxRow>
                            <ST.Col sm={6} md={6}>
                                <ContentBlock  {...productsData.internet} />
                                <ContentBlock  {...productsData.movix} />
                                <Apps />
                            </ST.Col>
                            <ST.Col sm={6} md={6}>
                                <ContentBlock  {...productsData.tv} contentReverse />
                                <ContentBlock  {...productsData.videocontrol} contentReverse />
                                <ContentBlock  {...productsData.domofon} />
                                <Join />
                            </ST.Col>
                        </FlexBoxRow>
                    )}
                    {currentWidth === 'mobile' && (
                        <FlexBoxRow>
                            <ST.Col xs={12}>
                                {map(productsData, item => <ContentBlock key={item.id} {...item} />)}
                                <Apps />
                                <Join />
                            </ST.Col>
                        </FlexBoxRow>
                    )}
                </IndentContainer>
                <Disclaimer />
            </WideContainer>
        </ST.SBlockContainer>
    );
};

export default Products;
